<template>
  <v-row>
    <v-col cols="6">
      <v-text-field
        v-model="inputedValue.orderNumber"
        :placeholder="$t('order.order_order-number')"
        outlined
        dense
        hide-details
        :height="height"
      >
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    value: {},
    height: { default: '32px' }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
